// React for Website
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
//outsource
import { Row, Col, Button, Divider, Form, Alert, message } from "antd";
import { DOMAIN_WEBSITE } from "../../../config/config";
import { MODEL_VOUCHER } from "../../../model/voucher";

//components
import VoucherName from "./component/voucher_name";
import VoucherLink from "./component/voucher_link";
import VoucherStatus from "./component/voucher_status";
import VoucherExpiry from "./component/voucher_expiry";
import VoucherTerm from "./component/voucher_term";
import VoucherId from "./component/voucher_id";

//redux
import { useDispatch, useSelector } from "react-redux";
import {
  snapBranchs,
  unSnapBranchs,
} from "../../../store/branch/branch.action";
import { addVoucherPackage } from "../../../store/voucher/voucher.action";
import {
  branchsSelector,
  detailSelector,
} from "../../../store/branch/branch.selector";
import { ownerSelector } from "../../../store/role/role.selector";
import { accountSelector } from "../../../store/stripe/stripe.selector";

const VoucherAdd = () => {
  // -------------------------- VAR --------------------------
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const params = useParams();
  const id = params.id;

  // -------------------------- STATE --------------------------
  const [shop, setShop] = useState(null);
  const [href, setHref] = useState("");
  const [voucherId, setVoucherId] = useState("");
  const [loading, setLoading] = useState(false);

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const owner = useSelector(ownerSelector);
  // const branches = useSelector(branchesOwnerSelector);
  const account = useSelector(accountSelector);
  // console.log({account})
  const branch = useSelector(detailSelector);
  const branches = [branch] || [];

  // console.log("branches", branches);
  const ownerId = owner?.id || "";
  // -------------------------- FUNCTION --------------------------

  const onFinish = (values) => {
    const status = account?.individual?.verification?.status;
    if (shop && status === "verified") {
      setLoading(true);
      const name = shop?.name;
      const shopId = shop?.shopId;
      const branch = shop?.id;
      const update = {
        ...values,
        name,
        shopId,
        branch,
        owner: ownerId,
      };

      //   console.log("update", update);

      if (update) {
        dispatch(
          addVoucherPackage({ dataPackage: update }, (response) => {
            if (response.status === 200) {
              setLoading(false);
              message.success("The Voucher Package was add!");
              navigate(`/branchs/detail/${id}/voucher`);
            } else {
              setLoading(false);
              message.error(response?.data || "Please try again !");
            }
          })
        );
      }
    } else {
      message.error(
        "Your account hasn't been verified or you dont have a account ! Please try again !"
      );
    }
  };

  const onFinishFailed = (error) => {
    console.log("error", error);
  };

  // -------------------------- EFFECT --------------------------

  //allBranch
  useEffect(() => {
    dispatch(snapBranchs());

    return () => dispatch(unSnapBranchs());
  }, [dispatch]);

  useEffect(() => {
    if (shop) {
      const shopId = shop?.shopId;
      setHref(`${DOMAIN_WEBSITE}/shop/${shopId}/${voucherId}`);
    }
  }, [shop, voucherId]);

  //import data
  useEffect(() => {
    if (form) {
      form.setFieldsValue(MODEL_VOUCHER);
    }
  }, [form]);

  //setShop
  useEffect(() => {
    if (id) {
      form.setFieldsValue({ name: id });
      setShop(branch);
    }
  }, [id]);

  // -------------------------- RENDER --------------------------
  const renderTitle = () => {
    return (
      <Row>
        <Col lg={12} md={12} sm={24} xs={24}>
          <b style={{ fontSize: 18 }}>Add a Voucher</b>
        </Col>
        <Col align="right" lg={12} md={12} sm={24} xs={24}>
          {renderButtonGroup()}
        </Col>
      </Row>
    );
  };

  const renderButtonGroup = () => {
    const disabled = shop ? shop?.name === "" : true;
    return (
      <Row justify="end" gutter={[10, 10]}>
        <Col>
          <Button
            onClick={() => navigate(`/branchs/detail/${id}/voucher`)}
            loading={loading}
            style={{ width: 120 }}
            type="default"
          >
            Cancel
          </Button>
        </Col>
        <Col>
          <Button
            form="voucher-add-form"
            htmlType="submit"
            style={{ width: 120 }}
            type="primary"
            loading={loading}
            disabled={disabled}
          >
            Save
          </Button>
        </Col>
      </Row>
    );
  };

  const renderVoucherDetails = () => {
    return (
      <Row>
        <Col lg={8} md={8} sm={24} xs={24}>
          <h1>Campaign Details</h1>
          <p>Basic information about the MKT campaign</p>
        </Col>
        <Col lg={16} md={16} sm={24} xs={24}>
          {renderFormDetail()}
        </Col>
      </Row>
    );
  };

  const renderFormDetail = () => {
    return (
      <Row gutter={[20, 20]}>
        <Col lg={12} md={12} sm={24} xs={24}>
          <VoucherName setShop={setShop} branches={branches} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <VoucherId form={form} setVoucherId={setVoucherId} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <VoucherLink href={href} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <VoucherStatus />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <VoucherExpiry form={form} />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <Alert
            message="Please check with the law of your country, as some prohibit the use of expiry dates"
            type="warning"
            showIcon
            closable
          />
        </Col>
      </Row>
    );
  };

  const renderTerms = () => {
    return (
      <Row>
        <Col lg={8} md={8} sm={24} xs={24}>
          <h1>Term Settings</h1>
          <p>Details to help customer make payment</p>
        </Col>
        <Col lg={16} md={16} sm={24} xs={24}>
          {renderTermSetting()}
        </Col>
      </Row>
    );
  };

  const renderTermSetting = () => {
    return (
      <Row>
        <Col lg={24} md={24} sm={24} xs={24}>
          <VoucherTerm shop={shop} form={form} />
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Row id="voucher-add">
      <Col lg={24} md={24} sm={24} xs={24}>
        {renderTitle()}
      </Col>
      <Divider />
      <Col lg={24} md={24} sm={24} xs={24}>
        <Form
          id="voucher-add-form"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={form}
          type="basic"
          layout="vertical"
          autoComplete="off"
        >
          {renderVoucherDetails()}
          <Divider />
          {renderTerms()}
        </Form>
      </Col>
    </Row>
  );
};

export default VoucherAdd;
